<ng-container *ngIf="openModal === 'order-info'">
  <app-orders-info></app-orders-info>
</ng-container>

<ng-container *ngIf="openModal === 'reviews-info'">
  <app-reviews-info></app-reviews-info>
</ng-container>